function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  d: "M113.49,58.82c0,34.17-1.2,81.4-17.41,99.12 c-1.78,1.94-3.76,3.65-5.84,5.15c-15.05,10.83-35.56,10.83-50.61,0c-2.08-1.5-4.06-3.21-5.83-5.15 c-16.13-17.63-17.4-64.45-17.42-98.58c0.07,0.84,0.44,2.24,2.16,2.24c4.65,0,14.19,29.65,43.28,30.38l5.47,0.01 c29.56-0.33,39.2-30.39,43.88-30.39C113.37,61.6,113.49,59.31,113.49,58.82z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M64.94,18.53V92l-3.12-0.02C32.73,91.25,23.19,61.6,18.54,61.6c-1.72,0-2.09-1.4-2.16-2.24 c0-0.01,0-0.01,0-0.02v-0.61c0-21.01,20.03-32.27,34.36-37.63C55.32,19.39,60.13,18.53,64.94,18.53z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M113.49,58.73c0,0,0,0.03,0,0.09c0,0.49-0.12,2.78-2.32,2.78c-4.68,0-14.32,30.06-43.88,30.39 C67.13,92,64.94,92,64.94,92V18.53c4.8,0,9.6,0.86,14.19,2.57C93.46,26.46,113.49,37.72,113.49,58.73z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M79.05,21.1c-4.59-1.71-9.39-2.57-14.19-2.57c-4.81,0-9.62,0.86-14.2,2.57 C36.33,26.46,16.3,37.72,16.3,58.73v0.61c0,0.01,0,0.01,0,0.02c0.02,34.13,1.29,80.95,17.42,98.58c1.77,1.94,3.75,3.65,5.83,5.15 c15.05,10.83,35.56,10.83,50.61,0c2.08-1.5,4.06-3.21,5.84-5.15c16.21-17.72,17.41-64.95,17.41-99.12c0-0.06,0-0.09,0-0.09 C113.41,37.72,93.38,26.46,79.05,21.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M64.86,18.53c4.8,0,9.6,0.86,14.19,2.57c14.33,5.36,34.36,16.62,34.36,37.63c0,0,0,0.03,0,0.09 c0,34.17-1.2,81.4-17.41,99.12c-1.78,1.94-3.76,3.65-5.84,5.15c-7.52,5.41-16.41,8.12-25.3,8.12s-17.78-2.71-25.3-8.12 c-2.08-1.5-4.06-3.21-5.83-5.15c-16.13-17.63-17.4-64.45-17.42-98.58c0-0.01,0-0.01,0-0.02v-0.61c0-21.01,20.03-32.27,34.36-37.63 C55.24,19.39,60.05,18.53,64.86,18.53 M64.86,3.53c-6.65,0-13.2,1.18-19.45,3.52C16.96,17.69,1.3,36.04,1.3,58.73v0.61 c0.03,44.39,2.63,88.26,21.35,108.73c2.35,2.58,5.09,5.01,8.12,7.19c9.96,7.17,21.74,10.96,34.08,10.96s24.11-3.79,34.07-10.95 c3.02-2.18,5.76-4.59,8.13-7.18c9.42-10.3,15.5-27.18,18.61-51.64c2.42-19.03,2.75-39.81,2.75-57.62v-0.09 c0-22.69-15.66-41.04-44.1-51.68C78.03,4.71,71.49,3.53,64.86,3.53L64.86,3.53z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_2_)",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M111.21,63.01 c-0.78,0.19-2.82,3.06-4.46,5.36c-6.15,8.66-17.61,24.79-39.47,25.03l-5.5-0.01c-21.44-0.54-32.75-16.46-38.83-25.02 c-1.64-2.31-3.68-5.18-4.42-5.36c-0.26,0-0.5-0.02-0.73-0.06c0.15,38.05,2.52,78.16,17.04,94.03c1.61,1.76,3.5,3.43,5.61,4.95 c7.14,5.14,15.61,7.86,24.48,7.86s17.34-2.72,24.48-7.85c2.11-1.52,4-3.19,5.62-4.96c14.49-15.84,16.88-55.92,17.03-94.06 C111.8,62.98,111.52,63.01,111.21,63.01C111.22,63.01,111.22,63.01,111.21,63.01z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_3_)",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M18.54,60.18 c2.07,0,3.72,2.33,6.73,6.56c6.2,8.72,16.57,23.32,36.56,23.83l1.69,0.01v-70.6c-4.2,0.15-8.32,0.98-12.29,2.45 c-15.25,5.71-33.44,16.64-33.44,36.3v0.57C17.88,60.18,18.23,60.18,18.54,60.18z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_4_)",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M104.44,66.74 c3-4.23,4.66-6.55,6.72-6.55c0.22,0,0.9,0,0.9-1.45c0-19.67-18.18-30.6-33.44-36.3c-3.97-1.48-8.09-2.3-12.28-2.46v70.61 c0.42,0,0.8,0,0.92-0.01C87.67,90.35,98.17,75.57,104.44,66.74z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M67.13,59.07h-4.4c-1.13,0-2.04-0.91-2.04-2.04 V38.75c0-1.13,0.91-2.04,2.04-2.04h4.4c1.13,0,2.04,0.91,2.04,2.04v18.29C69.17,58.16,68.26,59.07,67.13,59.07z"
});

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 42,
  height: 55,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAA4CAYAAABkHwH1AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAw9JREFUeNrsmd1u4yAQhRmM0+t9 /4fMfWJglcqsZidnhgG70UprJETauO6Xk+P5gRCucY1rfI97CHT2PenTYL9CqB+HBYCee9Uj0HQQ kgbuVY9C00FIbdVAtdUFTYOgaKUONAer4Oc/1/SAaRK0N6WqvekCToN2aTARvI4O2CJW/prCEWXv WM0oAKP4HQEbNCg0JbyqLk2CtrmIFanLgfI+C1uLgFWBk+PrJwC8KJMDS1Uzey+D/1WUMDflWalo Ymub/JoAFN0MX//l2dc3K9VNzpiKVG2AK1sXAMtBY+cBJEvdNGABpOwL8LavK1ObAOyTfQiuetxX 6kWEERuQAE076E0ALwyqAFVRdHABpwMWWJmyXww4sb8pQFXu42VfCdQZVfo2DUYBBHwTwEkouxkP XFZiNEwSacAClrpfQl0NlttiAQmmWCAznu3ZQcIuAnwDcTk6KrehaKA9ZKuwwyqCf2RR4QX6UEBl 9VZnlPWGsFVEhMDCWBZJREvPdLYNrJSbGExgoSkByKiUljQLS0aZqPl4YbAEAGOn/j2srMfHsmxs oSoqNW+vw3gbcbDw7pWYKKF43nMND2w1yrba6WCr870fsQHqn1DVT+IBQx1BtbrdGdhqgMr2hKfP NrKYxQA+RVkLkteq216wEEubLWuNQE+ViJaqWQGNLBk02Oc+NwE+rHKaUDWLgoSDEgtXXNkHAFab xaM9mLQAB32I7qAosB7gaRt4QJ8iY1XxkLXrHx3gQzaonYcrK19/MTqFh/DvsBUS2uy9v/f9CFTW obxViSLOIitkoGyw9r1GQxffrNhEF1tEm4K626ehbtcKntBFovPMyhZREYoHEOa4X8/xLLBCUICl RRawfVSUuGx5tp6RbosRKTILYdpeV1ay2Rvg0MacUNcLG0Elh1J0cUSD6Thr7fZVUFxrH6gae7Tz +7OdfVpyVP9IXWsH/Pu6Q9v0zA5IYb57Qp3TGteZwtlHS+Q4rellxJ85rRk4Yvo3zsEch3eee33u hLEDPQr7mbNbJ7j6sIZrXOM/Gr8FGAA17i0oziqytAAAAABJRU5ErkJggg==",
  transform: "matrix(1 0 0 1 43.7892 20.4428)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#EA0000",
  d: "M65.33,58.08h-0.79c-1.6,0-2.9-1.3-2.9-2.9V40.6c0-1.6,1.3-2.9,2.9-2.9h0.79c1.6,0,2.9,1.3,2.9,2.9v14.57 C68.23,56.78,66.93,58.08,65.33,58.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M65.33,58.08h-0.79c-1.6,0-2.9-1.3-2.9-2.9 V40.6c0-1.6,1.3-2.9,2.9-2.9h0.79c1.6,0,2.9,1.3,2.9,2.9v14.57C68.23,56.78,66.93,58.08,65.33,58.08z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 39.39,
  x2: 67.29,
  y2: 39.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 40.39,
  x2: 67.29,
  y2: 40.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 41.39,
  x2: 67.29,
  y2: 41.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 42.39,
  x2: 67.29,
  y2: 42.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 43.39,
  x2: 67.29,
  y2: 43.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 44.39,
  x2: 67.29,
  y2: 44.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 45.39,
  x2: 67.29,
  y2: 45.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 46.39,
  x2: 67.29,
  y2: 46.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 47.39,
  x2: 67.29,
  y2: 47.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 48.39,
  x2: 67.29,
  y2: 48.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 49.39,
  x2: 67.29,
  y2: 49.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 50.39,
  x2: 67.29,
  y2: 50.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 51.39,
  x2: 67.29,
  y2: 51.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 52.39,
  x2: 67.29,
  y2: 52.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 53.39,
  x2: 67.29,
  y2: 53.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 54.39,
  x2: 67.29,
  y2: 54.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 55.39,
  x2: 67.29,
  y2: 55.39
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  x1: 62.57,
  y1: 56.39,
  x2: 67.29,
  y2: 56.39
})));

var SvgScrollAnim = function SvgScrollAnim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.04 187.27",
    enableBackground: "new 0 0 129.04 187.27",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("g", null, _ref5, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 64.8535,
    cy: 94.8719,
    r: 78.6844,
    gradientTransform: "matrix(-1 0 0 -1.5 129.7069 237.1798)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6443,
    style: {
      stopColor: "#A7A7A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ref6), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.4996,
    y1: 174.0656,
    x2: 15.6545,
    y2: 16.3754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1907,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3343,
    style: {
      stopColor: "#2E2E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5337,
    style: {
      stopColor: "#403F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7659,
    style: {
      stopColor: "#5E5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#837E7E"
    }
  })), _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.2176,
    y1: 167.9274,
    x2: 21.8233,
    y2: 10.2372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1907,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3343,
    style: {
      stopColor: "#2E2E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5337,
    style: {
      stopColor: "#403F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7659,
    style: {
      stopColor: "#5E5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#837E7E"
    }
  })), _ref8, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.3677,
    y1: 155.8987,
    x2: 44.4944,
    y2: -0.2703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1907,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3343,
    style: {
      stopColor: "#2E2E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5337,
    style: {
      stopColor: "#403F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7659,
    style: {
      stopColor: "#5E5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#837E7E"
    }
  })), _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollAnim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Scroll Anim.a32acb89.svg";
export { ForwardRef as ReactComponent };